import '@/styles/global.css';
import '@/styles/swiper.css';

export const shouldUpdateScroll = () => false;
